// extracted by mini-css-extract-plugin
module.exports = {"searchText":"articles-not-found-block_searchText__ZmH0C"};